import React from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import '../../../ui/accordions/Accordion/index.js';
import '../../../ui/accordions/AccordionSelect/index.js';
import '../../../ui/badges/Badge/index.js';
import '../../../ui/badges/BadgeIcon/index.js';
import '../../../ui/badges/Checked/index.js';
import '../../../ui/badges/Panel/index.js';
import '../../../ui/badges/Status/index.js';
import '../../../ui/badges/Tag/index.js';
import '../../../ui/buttons/BabyButton/Base.js';
import '../../../ui/buttons/BabyButton/variants/Chat/index.js';
import '../../../ui/buttons/BabyButton/variants/Menu/index.js';
import '../../../ui/buttons/BabyButton/variants/User/index.js';
import '../../../ui/buttons/BabyButton/variants/Vip/index.js';
import '../../../ui/buttons/BabyButton/variants/Wallet/index.js';
import '../../../ui/buttons/Button/index.js';
import '../../../ui/buttons/CloseButton/index.js';
import '../../../ui/buttons/DirectionButton/index.js';
import '../../../ui/buttons/GradientButton/index.js';
import '../../../ui/buttons/GradientButtonV2/index.js';
import '../../../ui/buttons/TabButton/index.js';
import '../../../ui/buttons/TabButtonV2/index.js';
import '../../../ui/buttons/TimerButton/index.js';
import '../../../ui/buttons/TimerButtonV2/index.js';
import '../../../ui/buttons/TimerButtonV3/index.js';
import '../../../ui/loaders/Loader/index.js';
import '../../../ui/loaders/ScreenLoader/index.js';
import '../../../ui/modals/Modal/MobileWrapperV2/index.js';
import '../../../ui/modals/Modal/Modal.js';
import '../../../ui/modals/Modal/ModalContentWrapper/index.js';
import '../../../ui/popups/Popper/index.js';
import '../../../ui/popups/Popup/BasePopup/index.js';
import '../../../ui/popups/Popup/Thumb/index.js';
import '../../../ui/popups/Popup/ThumbV2/index.js';
import '../../../ui/popups/Popup/InfoTooltip/index.js';
import '../../../ui/sliders/EmblaCarousel/index.js';
import '../../../ui/tables/Table/index.js';
import '../../../ui/tables/Table/TableTd/index.js';
import '../../../ui/tabs/Tabs/index.js';
import '../../../ui/tabs/TabsV2/index.js';
import '../../../ui/texts/CryptoValue/index.js';
import '../../../ui/texts/AmountValue/index.js';
import '../../../ui/texts/TitleWithCurrency/index.js';
import '../../../ui/texts/Text/index.js';
import '../../../ui/texts/TextNavigation/index.js';
import '../../../ui/texts/MinValue/index.js';
import { SocialsList } from '../../../ui/socials/SocialsList/index.js';
import styles from './index.module.scss.js';

const FooterContacts = ({
  data,
  className,
  style,
  ...props
}) => /* @__PURE__ */ React.createElement("div", { ...props, className: cx(styles.box, className), style }, /* @__PURE__ */ React.createElement("div", { className: styles.box__inner }, /* @__PURE__ */ React.createElement("div", { className: styles.top }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: styles.title }, data.title), /* @__PURE__ */ React.createElement(Link, { to: `mailto:${data.mail}`, className: styles.mail }, data.mail)), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: styles.title }, data.socials.title), /* @__PURE__ */ React.createElement(
  SocialsList,
  {
    data: data.socials.list,
    className: styles["socials-list"]
  }
))), /* @__PURE__ */ React.createElement("div", { className: styles["text-wrapper"] }, /* @__PURE__ */ React.createElement(
  "span",
  {
    className: cx(styles.text, {
      [styles.shadow]: data.readMore
    })
  },
  data.text
), data.readMore && /* @__PURE__ */ React.createElement(React.Fragment, null, data.readMore.link && /* @__PURE__ */ React.createElement(Link, { to: data.readMore.link, className: styles["read-more"] }, data.readMore.text), !data.readMore.link && data.readMore.onClick && /* @__PURE__ */ React.createElement(
  "button",
  {
    type: "button",
    onClick: data.readMore.onClick,
    className: cx(styles["read-more"], styles["read-more--button"])
  },
  data.readMore.text
)))));
FooterContacts.displayName = "FooterComponent.Contacts";

export { FooterContacts };
//# sourceMappingURL=index.js.map
